import {
  FormattedServiceRequestData,
  ServiceRequestListFilters,
} from "~/types";
import * as APITypes from "~/API";

export const getFilteredRequestList = ({
  filters,
  requestList,
  isAdminOrSuperAdmin,
}: {
  filters: ServiceRequestListFilters;
  requestList: FormattedServiceRequestData[];
  isAdminOrSuperAdmin: boolean;
}) => {
  let filteredList = requestList;

  if (filters.status) {
    filteredList = filteredList.filter((requestData) => {
      return requestData.status === filters.status;
    });
  }

  if (filters.type) {
    filteredList = filteredList.filter((requestData) => {
      return requestData.type === filters.type;
    });
  }

  if (filters.title) {
    filteredList = filteredList.filter((requestData) => {
      return requestData.title.includes(filters.title || "");
    });
  }

  if (filters.handlerName) {
    filteredList = filteredList.filter((requestData) => {
      return (requestData.handlerName || "").includes(
        filters.handlerName || ""
      );
    });
  }

  if (filters.tenantName) {
    filteredList = filteredList.filter((requestData) => {
      return (requestData.tenantName || "").includes(filters.tenantName || "");
    });
  }

  if (filters.contractor) {
    filteredList = filteredList.filter((requestData) => {
      return (requestData.contractor || "").includes(filters.contractor || "");
    });
  }

  if (filters.createdAtIntervalStart) {
    // const filterStartDate = new Date(filters.createdAtIntervalStart);
    // filteredList = filteredList.filter((requestData) => {
    //   const createdAt = new Date(requestData.dateCreated.toString());
    //   return createdAt.getTime() >= filterStartDate.getTime();
    // });
  }

  if (filters.createdAtIntervalEnd) {
    // const filterEndDate = new Date(filters.createdAtIntervalEnd);
    // filteredList = filteredList.filter((requestData) => {
    //   const createdAt = new Date(requestData.dateCreated.toString());
    //   return createdAt.getTime() <= filterEndDate.getTime();
    // });
  }

  // Filter by access rights (only if not admin/superadmin)
  if (!isAdminOrSuperAdmin) {
    filteredList = filteredList.filter((requestData) => {
      return (
        requestData.accessRights?.readAccessStatus ===
          APITypes.ResourceAccessRightStatus.Granted ||
        requestData.accessRights?.writeAccessStatus ===
          APITypes.ResourceAccessRightStatus.Granted
      );
    });
  }

  return filteredList;
};
